module.exports = __webpack_public_path__ + "media/images/countrysquared/ml-446728b4736ff13d335cbce5d5c1db9d.svg";